<template>
  <div>
    <k-mask v-if="visible"></k-mask>
    <k-dialog v-if="visible" class="k-message k-flex" disable-lock>
      <div class="k-message__win">
        <p class="k-message__tt">{{ title }}</p>
        <div class="k-message__text" v-html="html"></div>
        <div class="btn btn-close" @click="visible = false">
          <span>{{ confirm || '点击关闭' }}</span>
        </div>
      </div>
    </k-dialog>
  </div>
</template>
<script>
import KMask from '@com/base/Mask';
import KDialog from '@com/base/Dialog';
export default {
  components: {
    KDialog,
    KMask
  },
  data() {
    return {
      title: '',
      html: '',
      confirm: '',
      visible: true
    };
  }
};
</script>
<style lang="scss" scoped>
.k-message {
  &__win {
    box-sizing: border-box;
    width: 602px;
    padding-top: 46px;
    border-radius: 16px;
    background-color: #fff;
    text-align: center;
  }
  &__tt {
    font-size: 26px;
    color: #535353;
    margin-top: -10px;
  }
  &__text {
    font-size: 26px;
    margin-top: 10px;
    margin-bottom: 42px;
    color: #535353;
    padding: 0 40px;
  }
  .btn-close {
    display: block;
    padding-top: 20px;
    padding-bottom: 35px;
    color: #58b65c;
    font-size: 24px;
    border-top: 1px solid #d9d9d9;
    text-align: center;
    span {
      font-size: inherit;
    }
    &:active {
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
